export enum FinOpsTabs {
  RECON = 'Recon',
  INVOICING = 'Invoicing',
  CHECKS = 'Checks',
  LOCKBOX = 'Lockbox',
  BANKING_BALANCE = 'Banking Balance',
  // PREFUND = 'Prefund',
}